/// <amd-module name="Build/Admin/Tabs/ProjectPoolsTab" />
import * as React from "react";

import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { Components, VssComponent, IVssComponentProperties, IVssComponentContext, WrappedComponent } from "VSS/Platform/Layout";

import { NavigationActionCreator } from "Build/Admin/Common/Actions/NavigationActionCreator";
import { PoolHubViewKeys } from "Build/Admin/Common/Constants";

export interface IProjectPoolsTabState {
    poolId: number | undefined;
    queueId: number | undefined;
    agentId: number | undefined;
    tabId: string | undefined;
}

class ProjectPoolsTab extends VssComponent<IVssComponentProperties, IProjectPoolsTabState> {
    private _navigationActionCreator: NavigationActionCreator;
    private _enabledAgentPoolChecksTab: boolean = false;

    constructor(props: IVssComponentProperties, context: IVssComponentContext) {
        super(props, context);
        this._navigationActionCreator = new NavigationActionCreator({ pageContext: context.pageContext });
        this._navigationActionCreator.validateQueryParameterValues();
        this.state = this._getState();

        if (this.state.queueId) {
            this._enabledAgentPoolChecksTab = isFeatureFlagEnabled(context.pageContext, "DistributedTask.EnabledAgentPoolChecksTab", false);
        }
    }

    public render(): JSX.Element {
        if (this.state.queueId
            && this.state.tabId === PoolHubViewKeys.Checks
            && !this._enabledAgentPoolChecksTab) {
            return <WrappedComponent
                dependencies={["ms.vss-build-web.admin.checks"]}
                wrappedType={"ms.vss-build-web.admin-checks-view-component"}
            />;
        }
        if ((this.state.queueId || this.state.poolId) && this.state.agentId) {
            return <WrappedComponent
                dependencies={["ms.vss-build-web.admin.agent"]}
                wrappedType={"ms.vss-build-web.admin-agent-view-component"}
            />;
        }
        else if (this.state.queueId) {
            return <WrappedComponent
                dependencies={["ms.vss-build-web.admin.pool"]}
                wrappedType={"ms.vss-build-web.admin-pool-view-component"}
            />;
        }
        else {
            return <WrappedComponent
                dependencies={["ms.vss-build-web.admin.poolslist"]}
                wrappedType={"ms.vss-build-web.admin-pools-list-view-component"}
            />;
        }
    }

    private _getState(): IProjectPoolsTabState {
        return {
            poolId: this._navigationActionCreator.getPoolIdParam(),
            queueId: this._navigationActionCreator.getQueueIdParam(),
            agentId: this._navigationActionCreator.getAgentIdParam(),
            tabId: this._navigationActionCreator.getTabIdParam()
        };
    }
}

Components.add("build-admin-project-pools-tab", ProjectPoolsTab);
